import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_SPERREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerSperrenAdmin laden';
export const POST_BENUTZER_SPERREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerSperrenAdmin ausführen';
export const POST_BENUTZER_SPERREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerSperrenAdmin laden erfolgreich';
export const POST_BENUTZER_SPERREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerSperrenAdmin Ladefehler';
export const POST_BENUTZER_SPERREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerSperrenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerSperrenAdminAction implements Action {
    readonly type = POST_BENUTZER_SPERREN_ADMIN;
        constructor(public benutzerSperrenRequest: api.BenutzerSperrenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerSperrenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_SPERREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerSperrenRequest: api.BenutzerSperrenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerSperrenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_SPERREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerSperrenRequest: api.BenutzerSperrenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerSperrenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_SPERREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerSperrenRequest: api.BenutzerSperrenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerSperrenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_SPERREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerSperrenAdminActions =
    PostBenutzerSperrenAdminAction
    | PostBenutzerSperrenAdminAusfuehrenAction
    | PostBenutzerSperrenAdminErfolgreichAction
    | PostBenutzerSperrenAdminFehlerAction
    | PostBenutzerSperrenAdminNichtAusgefuehrtAction
    ;
